import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  TextField,
  EditButton,
  Datagrid,
  SimpleList,
  DateField,
  FunctionField,
  ShowButton,
  TopToolbar,
  CreateButton,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { ACADEMIC_YEARS, MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import HolidaysDialog from "./HolidaysDialog";
import { SessionExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import { formatDateBg } from "server/formatting/formatDateBg";

const ListAcademicYears = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const UserPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={SessionExporter(ACADEMIC_YEARS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Академични години"
      actions={<ListActions hasCreate={checkPermission(UserPermissions, permissions.canCreateAcademicYears)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Стартира на", value: formatDateBg(record.opensOn) }]} />
              <MobileListRow fields={[{ label: "Приключва на", value: formatDateBg(record.closesOn) }]} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canUpdateAcademicYearHolidays}>
                  <HolidaysDialog
                    dateFrom={record?.opensOn?.split("T")[0]}
                    dateTo={record?.closesOn?.split("T")[0]}
                  />
                </SecuredComponent>
              </div>
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateAcademicYears}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewAcademicYearHolidays}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Име"
            sortable={false}
          />

          <DateField
            label="Стартира на"
            source="opensOn"
            showTime
            locales="bg-BG"
          />

          <DateField
            label="Приключва на"
            source="closesOn"
            showTime
            locales="bg-BG"
          />

          <SecuredComponent permission={permissions.canUpdateAcademicYearHolidays}>
            <FunctionField
              render={record => (
                <HolidaysDialog
                  dateFrom={record?.opensOn?.split("T")[0]}
                  dateTo={record?.closesOn?.split("T")[0]}
                />
              )}
            />
          </SecuredComponent>

          <SecuredComponent permission={permissions.canUpdateAcademicYears}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewAcademicYearHolidays}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListAcademicYears;
